import { Api } from './Api';

export default {
/*  1. Get all data */
    getSystems(keyword = '') {
        return Api().get(`/SAMASystem${keyword ? '?Keyword=' + keyword : ''}`);
    },

/*  2. Get one column */
    getSystem(id) {
        return Api().get(`/SAMASystem/${id}`);
    },

/*  3. Create one column */
    saveSystem(body) {
        return Api().post(`/SAMASystem`, body);
    },

/*  4. Delete one or more columns */
    deleteSystems(systems) {
        return Api().post(`/SAMASystem/DeleteSAMASystem`, systems);
    },

/*  5. post one or more columns */
    postSystems(systems) {
        return Api().post(`/SAMASystem/PostSAMASystem`, systems);
    },
}